import Swiper from 'swiper/bundle'

export default class TextImageSlider {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    const swiperEl = this.el.querySelector('.swiper')
    if (!swiperEl) return

    this.swiper = new Swiper(swiperEl, {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: this.el.querySelector('.text-image-slider--nav-next'),
        prevEl: this.el.querySelector('.text-image-slider--nav-prev'),
      },
    })
  }
}
